import { Api } from "../axios-config";

export interface ITestimony {
    _id: string;
    CourseId: string;
    ClientName: string;
    TestimonyText: string;
    PictureId?: string;
    PictureUrl?: string;
    order: number;
}

export interface IListTestimonies {
    data: ITestimony[];
}

const getAllTestimonies = async (): Promise<IListTestimonies | Error> => {
    try {
        const { data } = await Api.get("/testimonies");
        if (data) {
            return { data };
        } else {
            return new Error('Erro ao listar depoimentos');
        }
    } catch (error) {
        return new Error(`Erro ao listar depoimentos: ${error}`);
    }
};

export const TestimonyServices = {
    getAllTestimonies,
};
